import { Button } from "@chakra-ui/react"

const StyledButton = ({ children, ...props }) => (
    <Button
        bgColor="var(--button-bgcolor)"
        _hover={{ bgColor: "var(--button-bgcolor-hover)" }}
        color="#fff"
        borderRadius={0}
        p="20px 5px"
        fontSize="18px"
        fontWeight={500}
        width="100%"
        maxW="350px"
        {...props}
    >
        {children}
    </Button>
)

export default StyledButton
